/**
 * The supplemental questionnaire model.
 *
 * One form per commercial class, derived from the richest carrier supplemental
 * we hold for that class (Josh's rule, 2026-08-27: pick the one with the most
 * information and that's the good one). A superset can always produce a shorter
 * carrier's form; the reverse is impossible, so the richest is the safe base.
 *
 * The form is CLASS-level, not carrier-level, on purpose. Connor routinely
 * returns fifteen markets for a risk. If the questionnaire were per carrier, an
 * agent approaching four of them would fill four overlapping forms and would
 * stop on the second. Fill once, produce any carrier's paperwork from it.
 *
 * These types are shared so the extractor that writes a definition, the API that
 * stores it, and the renderer that draws it cannot drift apart.
 */
/** How much of the form is answered, for the progress a member sees. */
export function completeness(form, answers, audience) {
    const visible = form.fields.filter((f) => {
        if (audience && f.audience !== 'either' && f.audience !== audience)
            return false;
        if (!f.showIf)
            return true;
        return answers[f.showIf.field] === f.showIf.equals;
    });
    const answered = visible.filter((f) => {
        const v = answers[f.id];
        if (v === undefined || v === null || v === '')
            return false;
        return Array.isArray(v) ? v.length > 0 : true;
    }).length;
    return {
        answered,
        total: visible.length,
        pct: visible.length ? Math.round((100 * answered) / visible.length) : 0,
    };
}
